import React from 'react'

const QuickSendButton = ({ onClick, text, icon, class: className }) => {
  function handleClick(e) {
    e.preventDefault()
    onClick && onClick()
  }

  return (
    <a href="#quick-send" className={className || "btn btn-secondary"} onClick={handleClick} role="button">
      { icon && (
        <>
          <i className={`fa fa-${icon}`} />
          { " " }
        </>
      )}
      { text || "Quick Send" }
    </a>
  )
}

export default QuickSendButton
